<template>
  <div style="position: relative;">
    <!-- div  :style="{'background-image': 'url(' + require('@/assets/mission.jpg') + ')'}" style="background-size: cover; background-position: center bottom;" -->
    <div  style="background-color: #424242; background-size: cover; background-position: center bottom;">

      <v-container flex grid-list-lg class="pa-3">
        <div style="max-height: 8px; height: 8px;" class="hidden-md-and-up">&nbsp;</div>

        <v-layout
          wrap
        >

          <v-flex xs7 sm6 offset-md1 offset-xl2 class="pa-0" style="background-size: 36%; background-position: left bottom;">
            <v-card-text  class="pa-0" style="color: #eee !important;">
              <p class="pt-1 pb-1 pl-2 ma-0"  >{{cat}}: <span class="font-weight-bold">{{title}}</span></p>
            </v-card-text>
          </v-flex>
          <v-flex sm6 md4 lg4 xl2 class="pa-0 text-xs-right hidden-sm-and-down ma-0" >
          <v-btn small dark rounded depressed  class="ma-0 grey--text lighten-2 mr-3" color="grey darken-4">
            <v-icon small left light>mdi-email</v-icon>
            forward
          </v-btn>
            <v-btn small dark round depressed  class="ma-0 grey--text lighten-2 mr-3" color="grey darken-4">
              <v-icon small left light>mdi-facebook</v-icon>
              like

            </v-btn>
            <v-btn small dark round depressed  class="ma-0 grey--text lighten-2" color="grey darken-4">
              <v-icon small left light>mdi-twitter</v-icon>
              tweet

            </v-btn>
            </v-flex>
          <v-flex xs5 sm6 xl2 class="pa-0 text-xs-right hidden-md-and-up ma-0" >
            <v-btn small dark round depressed  class="ma-0 grey--text lighten-2" color="grey darken-4">
              <v-icon small left light>mdi-share</v-icon>
              share

            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>

    </div>

  </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  components: {

  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Title'
    },
    cat: {
      type: String,
      required: false,
      default: 'Subtitle'
    },
    line1: {
      type: String,
      required: false,
      default: ''
    },
    line2: {
      type: String,
      required: false,
      default: ''
    },
    line3: {
      type: String,
      required: false,
      default: ''
    },
    icon1: {
      type: String,
      required: false,
      default: ''
    },
    icon2: {
      type: String,
      required: false,
      default: ''
    },
    icon3: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      tabs: 0,
      tabs2: 0,
      panel: 0,
      expand: null,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    }
  },
  computed: {
    ...mapGetters({
      tabVersion: 'version/tabVersion'
    })
  },
  methods: {
    ...mapActions({
      updateTabVersion: 'version/updateTabVersion'
    })
  }
}
</script>

<style>

</style>
